<template>
  <div>
    <!-- Header with Search and Button -->
    <v-row align="center" class="">
      <v-col cols="12">
        <div
          class="d-flex flex-wrap justify-space-between align-center ga-2 page-header"
        >
          <div>
            <div class="page-title">Students</div>
            <div class="text-subtitle-2 mt-1">
              <span class="text-grey"
                >Manage student submissions and track OJT progress</span
              >
            </div>
          </div>
          <div>
            <v-btn
              :color="$vuetify.theme.themes.light.submitBtnsGreen"
              class="white--text mx-1 text-none"
              @click="upload"
              prepend-icon="mdi-upload-outline"
              rounded="lg"
              elevation="0"
              v-if="role == 1 && !studentData"
            >
              Upload
            </v-btn>
          </div>
        </div>
      </v-col>

      <v-col
        cols="12"
        class="d-flex justify-space-between align-center flex-wrap ga-2"
      >
        <v-tabs
          v-if="role == 2"
          v-model="activeTab"
          color="#519043"
          align-tabs="left"
          class="section-tabs"
        >
          <v-tab
            v-for="tab in tabList"
            :value="tab.name"
            :key="tab.id"
            @click="changeTab(tab)"
            class="text-none"
            >{{ tab.name }}</v-tab
          >
        </v-tabs>
        <v-btn
          v-if="role == 2 && tab == 1"
          :color="$vuetify.theme.themes.light.submitBtnsGreen"
          class="white--text text-none"
          size="small"
          @click="addClassSet"
          prepend-icon="mdi-upload-outline"
          rounded="lg"
          elevation="0"
        >
          Add Set
        </v-btn>

        <div style="width: 50%" v-if="tab == 2">
          <v-autocomplete
            v-model="status_selected"
            :items="status_list"
            item-value="id"
            @update:modelValue="getStudentSubmissionTableData"
            item-title="name"
            label="Status"
            variant="outlined"
            density="compact"
            class="rounded-lg"
            hide-details
            :color="$vuetify.theme.themes.light.inputColor"
          ></v-autocomplete>
        </div>
      </v-col>

      <!-- OJT Coordiantor -->
      <v-col cols="12" v-if="tab == 1 && role == 1">
        <div class="">
          <v-row v-if="tab == 1 && !expandTab1">
            <v-col cols="12" sm="6">
              <v-text-field
                v-model="search"
                label="Search"
                prepend-inner-icon="mdi-magnify"
                variant="outlined"
                density="compact"
                hide-details
                clearable
                color="primary"
                class="rounded-lg"
              />
            </v-col>
            <v-col cols="12" sm="6">
              <v-autocomplete
                v-model="batch_selected"
                @update:modelValue="initialize"
                :items="batchList"
                item-value="id"
                :item-title="(item) => `${item.name}  (${item.year})`"
                label="Please Select Batch"
                variant="outlined"
                density="compact"
                hide-details
                class="rounded-lg"
                :color="$vuetify.theme.themes.light.inputColor"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12">
              <div v-if="!showDataTable">
                <!-- Stat Cards -->
                <v-row dense class="py-2" v-if="isDataLoaded">
                  <v-col cols="12" sm="4">
                    <div
                      @click="showDataTable = true"
                      class="stat-box rounded-lg pa-3 d-flex align-center cursor-pointer"
                      style="background-color: #6aa3ea; color: white"
                    >
                      <div class="stat-icon-wrap mr-3">
                        <v-icon size="44">mdi-account-multiple</v-icon>
                      </div>
                      <div>
                        <div
                          class="text-caption font-weight-bold text-uppercase"
                        >
                          Total Interns
                        </div>
                        <div class="text-h4 font-weight-bold">
                          {{ all_student_cnt }}
                        </div>
                      </div>
                      <v-spacer />
                      <v-icon size="18" style="opacity: 0.5"
                        >mdi-chevron-right</v-icon
                      >
                    </div>
                  </v-col>
                  <v-col cols="12" sm="4">
                    <div
                      @click="showDataTable = true"
                      class="stat-box rounded-lg pa-3 d-flex align-center cursor-pointer"
                      style="background-color: #5eaf9b; color: white"
                    >
                      <div class="stat-icon-wrap mr-3">
                        <v-icon size="44">mdi-account-check</v-icon>
                      </div>
                      <div>
                        <div
                          class="text-caption font-weight-bold text-uppercase"
                        >
                          Profiles Completed
                        </div>
                        <div class="text-h4 font-weight-bold">
                          {{ profileData[0].value }}
                        </div>
                      </div>
                      <v-spacer />
                      <v-chip
                        size="x-small"
                        color="white"
                        variant="tonal"
                        class="mt-1"
                      >
                        {{ completionPct }}%
                      </v-chip>
                    </div>
                  </v-col>
                  <v-col cols="12" sm="4">
                    <div
                      @click="showDataTable = true"
                      class="stat-box rounded-lg pa-3 d-flex align-center cursor-pointer"
                      style="background-color: #f1a340; color: white"
                    >
                      <div class="stat-icon-wrap mr-3">
                        <v-icon size="44">mdi-account-alert</v-icon>
                      </div>
                      <div>
                        <div
                          class="text-caption font-weight-bold text-uppercase"
                        >
                          Pending Profiles
                        </div>
                        <div class="text-h4 font-weight-bold">
                          {{ profileData[1].value }}
                        </div>
                      </div>
                      <v-spacer />
                      <v-icon size="18" style="opacity: 0.5"
                        >mdi-chevron-right</v-icon
                      >
                    </div>
                  </v-col>
                </v-row>

                <!-- Chart Cards -->
                <v-row dense class="mt-2" v-show="isDataLoaded">
                  <!-- Profile Completion -->
                  <v-col cols="12" md="4">
                    <div class="card h-100">
                      <div class="card-title">Profile Completion</div>
                      <div class="profile-inner">
                        <div class="chart-wrap">
                          <canvas ref="profileChart" height="140"></canvas>
                        </div>
                        <div>
                          <div class="legend">
                            <div
                              class="legend-item"
                              v-for="item in profileData"
                              :key="item.label"
                            >
                              <div
                                class="legend-dot"
                                :style="{ background: item.color }"
                              ></div>
                              <span class="legend-label">{{ item.label }}</span>
                              <span class="legend-val">{{ item.value }}</span>
                            </div>
                          </div>
                          <div class="progress-bar-wrap">
                            <div class="progress-track">
                              <div
                                class="progress-fill"
                                :style="{ width: completionPct + '%' }"
                              ></div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </v-col>

                  <!-- Program Distribution -->
                  <v-col cols="12" md="4">
                    <div class="card h-100">
                      <div class="card-title">
                        Profile Completion per Program
                      </div>
                      <div class="chart-wrap">
                        <canvas ref="programChart" height="180"></canvas>
                      </div>
                    </div>
                  </v-col>

                  <!-- Skill Assessments Status -->
                  <v-col cols="12" md="4">
                    <div class="card h-100">
                      <div class="card-title">Skill Assessments Status</div>
                      <div class="profile-inner">
                        <div class="chart-wrap">
                          <canvas ref="deployChart" height="140"></canvas>
                        </div>
                        <div class="legend">
                          <div
                            class="legend-item"
                            v-for="item in deployData"
                            :key="item.label"
                          >
                            <div
                              class="legend-dot"
                              :style="{ background: item.color }"
                            ></div>
                            <span class="legend-label">{{ item.label }}</span>
                            <span class="legend-val">{{ item.value }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </v-col>
                </v-row>

                <v-row v-if="!isDataLoaded">
                  <v-col cols="4" v-for="i in 3" :key="i">
                    <v-skeleton-loader
                      class="mx-auto border"
                      max-width="300"
                      type="image, article"
                    ></v-skeleton-loader>
                  </v-col>
                </v-row>
              </div>
              <div v-if="showDataTable">
                <v-card flat class="rounded-lg table-card" border>
                  <v-data-table
                    :headers="headers"
                    :items="data"
                    :search="search"
                    :loading="loading"
                    hover
                    density="compact"
                    class="rounded-lg styled-table"
                  >
                    <template v-slot:[`item.name`]="{ item }">
                      <div class="py-2">
                        <div class="font-weight-medium">
                          {{ toTitleCase(item.name) }}
                        </div>
                        <div class="text-caption text-grey">
                          {{ item.school_id }}
                        </div>
                      </div>
                    </template>
                    <template v-slot:[`item.pg_abbr`]="{ item }">
                      <v-chip size="small" class="program-chip" label>{{
                        item.pg_abbr
                      }}</v-chip>
                    </template>
                    <template v-slot:[`item.progress`]="{ item }">
                      <div class="" style="width: 50%; margin: 0 auto">
                        <div class="text-caption text-grey mx-2">
                          {{ getProgress(item).submitted }}/{{
                            getProgress(item).toSubmit
                          }}
                        </div>
                        <v-progress-linear
                          :location="null"
                          color="green"
                          height="12"
                          :max="getProgress(item).toSubmit"
                          :model-value="getProgress(item).submitted"
                          rounded
                        ></v-progress-linear>
                      </div>
                    </template>

                    <template v-slot:[`item.review`]="{ item }">
                      <div>
                        <div class="text-caption text-grey mx-2">
                          {{ getForApprovalCount(item) }} For Approval
                        </div>
                      </div>
                    </template>

                    <template v-slot:[`item.actions`]="{ item }">
                      <v-btn
                        :color="$vuetify.theme.themes.light.submitBtnsGreen"
                        variant="text"
                        class="text-none"
                        @click="openGroup1(item)"
                        size="x-small"
                      >
                        View Requirements
                      </v-btn>
                    </template>

                    <template #no-data> No data found. </template>
                  </v-data-table>
                </v-card>
              </div>
            </v-col>
          </v-row>
          <v-row v-if="tab == 1 && expandTab1">
            <v-col cols="12" style="background-color: white; height: 80vh">
              <div>
                <div
                  @click="
                    expandTab1 = !expandTab1;
                    studentData = null;
                    initialize();
                  "
                  color="text-grey "
                  class="d-flex justify-start align-center text-subtitle-2 cursor-pointer back-link"
                >
                  <div><v-icon>mdi-chevron-left</v-icon></div>
                  <div>Back to List</div>
                </div>

                <div
                  class="student-summary-bar my-4 pa-4 d-flex justify-space-between align-center"
                >
                  <div>
                    <div class="text-h5 font-weight-bold">
                      {{ studentData.name }}
                    </div>
                    <div class="text-grey text-caption">
                      {{ studentData.school_id }} | {{ studentData.pg_abbr }}
                    </div>
                  </div>
                  <div
                    class="d-flex pa-2 align-center summary-stat-group rounded-lg bg-white"
                  >
                    <div class="mx-4 text-grey text-caption">
                      <div
                        class="text-center text-h5 font-weight-bold text-green-darken-1"
                      >
                        {{ getApprovedRequirementCount }}
                      </div>
                      <div class="text-overline text-grey mt-n2">Approved</div>
                    </div>
                    <div class="mx-4 text-grey text-caption">
                      <div
                        class="text-center text-h5 font-weight-bold text-amber-darken-2"
                      >
                        {{ getPendingRequirementCount }}
                      </div>
                      <div class="text-overline text-grey mt-n2">Pending</div>
                    </div>
                    <div class="mx-4 text-grey text-caption">
                      <div
                        class="text-center text-h5 font-weight-bold text-grey-darken-1"
                      >
                        {{ getMissingRequirementCount }}
                      </div>
                      <div class="text-overline text-grey mt-n2">Missing</div>
                    </div>
                  </div>
                </div>

                <div class="mt-2">
                  <div class="pa-2 text-h5 font-weight-bold">
                    Submitted Documents
                  </div>

                  <v-card flat class="rounded-lg table-card" border>
                    <!-- Table header with search -->

                    <v-data-table
                      :headers="requirements_headers"
                      :items="getStudentRequirement"
                      hover
                      density="compact"
                      class="rounded-lg styled-table"
                    >
                      <template v-slot:[`item.status`]="{ item }">
                        <div v-if="item.status == 1">
                          <v-chip
                            size="x-small"
                            class="status-chip status-review"
                            >For Approval
                          </v-chip>
                        </div>
                        <div v-else-if="item.status == 2">
                          <v-chip
                            size="x-small"
                            class="status-chip status-approved"
                            >Approved</v-chip
                          >
                        </div>
                        <div v-else-if="item.status == 3">
                          <v-chip
                            size="x-small"
                            class="status-chip status-pending"
                            >Pending</v-chip
                          >
                        </div>
                        <div v-else-if="item.status == null">
                          <v-chip size="x-small" class="status-chip status-none"
                            >No Submission</v-chip
                          >
                        </div>
                      </template>

                      <template v-slot:[`item.submitted_at`]="{ item }">
                        {{ formatDate(item.submission?.submitted_at) }}
                      </template>

                      <template v-slot:[`item.action`]="{ item, index }">
                        <v-btn
                          v-if="item.status != null"
                          :color="$vuetify.theme.themes.light.submitBtnsGreen"
                          variant="text"
                          class="text-none"
                          @click="viewSubmission(item, index)"
                          size="x-small"
                        >
                          View
                        </v-btn>
                      </template>
                    </v-data-table>
                  </v-card>
                </div>
              </div>
            </v-col>
          </v-row>
        </div>
      </v-col>

      <!--Ojt Instructor  -->
      <v-col cols="12" v-if="tab == 1 && role == 2">
        <div class="mt-4">
          <v-row v-if="tab == 1 && !expandTab1">
            <v-col cols="12">
              <v-card flat class="rounded-lg table-card" border>
                <v-data-table
                  :headers="headers"
                  :items="data"
                  :loading="loading"
                  hover
                  density="compact"
                  class="rounded-lg styled-table"
                >
                  <template v-slot:[`item.name`]="{ item }">
                    <div class="py-2">
                      <div class="font-weight-medium">{{ item.name }}</div>
                      <div class="text-caption text-grey">
                        {{ item.school_id }}
                      </div>
                    </div>
                  </template>
                  <template v-slot:[`item.abbr`]="{ item }">
                    <v-chip size="small" class="program-chip" label>{{
                      item?.program?.abbr
                    }}</v-chip>
                  </template>

                  <template v-slot:[`item.actions`]="{ item }">
                    <v-btn
                      color="warning"
                      variant="text"
                      class="text-none"
                      size="x-small"
                      @click="updateClassSet(item)"
                    >
                      Update
                    </v-btn>
                    <v-btn
                      :color="$vuetify.theme.themes.light.submitBtnsGreen"
                      variant="text"
                      class="text-none"
                      @click="openSetGroup(item)"
                      size="x-small"
                    >
                      View
                    </v-btn>
                  </template>

                  <template #no-data> No data found. </template>
                </v-data-table>
              </v-card>
            </v-col>
          </v-row>
          <v-row v-if="tab == 1 && expandTab1">
            <v-col cols="12" style="background-color: white; height: 80vh">
              <div>
                <div
                  @click="goBack()"
                  color="text-grey "
                  class="d-flex justify-start align-center text-subtitle-2 cursor-pointer back-link"
                >
                  <div><v-icon>mdi-chevron-left</v-icon></div>
                  <div>
                    {{
                      !expandTab1_instructor
                        ? "Back to Set Lists"
                        : "Back to Student Lists"
                    }}
                  </div>
                </div>

                <div v-if="!expandTab1_instructor" class="mt-4">
                  <div class="my-2" style="width: 40%">
                    <v-text-field
                      v-model="search"
                      label="Search"
                      prepend-inner-icon="mdi-magnify"
                      variant="outlined"
                      density="compact"
                      hide-details
                      clearable
                      class="mr-2 rounded-lg"
                      color="primary"
                    />
                  </div>
                  <v-card flat class="rounded-lg table-card" border>
                    <v-data-table
                      :headers="inst_headers"
                      :items="class_data_list"
                      :search="search"
                      :loading="loading"
                      hover
                      density="compact"
                      class="rounded-lg styled-table"
                    >
                      <template v-slot:[`item.name`]="{ item }">
                        <div class="py-2">
                          <div class="font-weight-medium">{{ item.name }}</div>
                          <div class="text-caption text-grey">
                            {{ item.school_id }}
                          </div>
                        </div>
                      </template>
                      <template v-slot:[`item.pg_abbr`]="{ item }">
                        <v-chip size="small" class="program-chip" label>{{
                          item.program_name
                        }}</v-chip>
                      </template>
                      <template v-slot:[`item.progress`]="{ item }">
                        <div class="" style="width: 50%; margin: 0 auto">
                          <div class="text-caption text-grey mx-2">
                            {{ getProgress(item).submitted }}/{{
                              getProgress(item).toSubmit
                            }}
                          </div>
                          <v-progress-linear
                            :location="null"
                            color="green"
                            height="12"
                            :max="getProgress(item).toSubmit"
                            :model-value="getProgress(item).submitted"
                            rounded
                          ></v-progress-linear>
                        </div>
                      </template>

                      <template v-slot:[`item.review`]="{ item }">
                        <div>
                          <div class="text-caption text-grey mx-2">
                            {{ getForApprovalCount(item) }} For Approval
                          </div>
                        </div>
                      </template>

                      <template v-slot:[`item.actions`]="{ item }">
                        <v-btn
                          :color="$vuetify.theme.themes.light.submitBtnsGreen"
                          variant="text"
                          class="text-none"
                          @click="openSubGroup(item)"
                          size="x-small"
                        >
                          View Requirements
                        </v-btn>
                      </template>

                      <template #no-data> No data found. </template>
                    </v-data-table>
                  </v-card>
                </div>
                <div v-if="expandTab1_instructor">
                  <div
                    class="student-summary-bar my-4 pa-4 d-flex justify-space-between align-center"
                  >
                    <div>
                      <div class="text-h5 font-weight-bold">
                        {{ studentData.name }}
                      </div>
                      <div class="text-grey text-caption">
                        {{ studentData.school_id }} |
                        {{ studentData.program_name }}
                      </div>
                    </div>
                    <div
                      class="d-flex pa-2 align-center summary-stat-group rounded-lg bg-white"
                    >
                      <div class="mx-4 text-grey text-caption">
                        <div
                          class="text-center text-h5 font-weight-bold text-green-darken-1"
                        >
                          {{ getApprovedRequirementCount }}
                        </div>
                        <div class="text-overline text-grey mt-n2">
                          Approved
                        </div>
                      </div>
                      <div class="mx-4 text-grey text-caption">
                        <div
                          class="text-center text-h5 font-weight-bold text-amber-darken-2"
                        >
                          {{ getPendingRequirementCount }}
                        </div>
                        <div class="text-overline text-grey mt-n2">Pending</div>
                      </div>
                      <div class="mx-4 text-grey text-caption">
                        <div
                          class="text-center text-h5 font-weight-bold text-grey-darken-1"
                        >
                          {{ getMissingRequirementCount }}
                        </div>
                        <div class="text-overline text-grey mt-n2">Missing</div>
                      </div>
                    </div>
                  </div>

                  <div class="mt-2">
                    <!-- <div class="pa-2 text-h5">Submitted Documents</div> -->
                    <div class="pa-2">
                      <v-tabs
                        v-model="activeSubmissionTab"
                        color="#519043"
                        align-tabs="left"
                        class="section-tabs"
                      >
                        <v-tab
                          v-for="tab in submissionTabList"
                          :value="tab.name"
                          :key="tab.id"
                          @click="changeSubmissionTab(tab)"
                          class="text-none"
                          >{{ tab.name }}</v-tab
                        >
                      </v-tabs>
                    </div>
                    <v-card flat class="rounded-lg table-card" border>
                      <v-data-table
                        :headers="requirements_headers"
                        :items="
                          submissionTab == 1
                            ? getStudentRequirement
                            : studentSubmissions
                        "
                        hover
                        density="compact"
                        class="rounded-lg styled-table"
                      >
                        <template v-slot:[`item.submitted_at`]="{ item }">
                          <div v-if="submissionTab == 1">
                            {{
                              item.submission
                                ? formatDate(item.submission.submitted_at)
                                : ""
                            }}
                          </div>
                          <div v-if="submissionTab == 2">
                            {{ formatDate(item.submitted_at) }}
                          </div></template
                        >
                        <template v-slot:[`item.status`]="{ item }">
                          <div v-if="item.status == 1">
                            <v-chip
                              size="x-small"
                              class="status-chip status-review"
                              >For Approval
                            </v-chip>
                          </div>
                          <div v-else-if="item.status == 2">
                            <v-chip
                              size="x-small"
                              class="status-chip status-approved"
                              >Approved</v-chip
                            >
                          </div>
                          <div v-else-if="item.status == 3">
                            <v-chip
                              size="x-small"
                              class="status-chip status-pending"
                              >Pending</v-chip
                            >
                          </div>
                          <div v-else-if="item.status == null">
                            <v-chip
                              size="x-small"
                              class="status-chip status-none"
                              >No Submission</v-chip
                            >
                          </div>
                        </template>
                        <template v-slot:[`item.action`]="{ item, index }">
                          <v-btn
                            v-if="item.status != null"
                            :color="$vuetify.theme.themes.light.submitBtnsGreen"
                            variant="text"
                            class="text-none"
                            @click="viewSubmission(item, index)"
                            size="x-small"
                          >
                            View
                          </v-btn>
                        </template>
                      </v-data-table>
                    </v-card>
                  </div>
                </div>
              </div>
            </v-col>
          </v-row>
        </div>
      </v-col>

      <!-- OJT Instructor DAILY SUBMISSION -->
      <v-col cols="12" v-if="tab == 2 && role == 2">
        <div class="mt-4">
          <v-row v-if="!expandTab1">
            <v-col cols="12">
              <v-card flat class="rounded-lg table-card" border>
                <v-data-table
                  :headers="headers"
                  :items="data"
                  :search="search"
                  :loading="loading"
                  hover
                  density="compact"
                  class="rounded-lg styled-table"
                >
                  <template v-slot:[`item.name`]="{ item }">
                    <div class="py-2">
                      <div class="font-weight-medium">{{ item.name }}</div>
                      <div class="text-caption text-grey">
                        {{ item.school_id }}
                      </div>
                    </div>
                  </template>
                  <template v-slot:[`item.pg_abbr`]="{ item }">
                    <v-chip size="small" class="program-chip" label>{{
                      item.pg_abbr
                    }}</v-chip>
                  </template>

                  <template v-slot:[`item.review`]="{ item }">
                    <div>
                      <div class="text-caption text-grey mx-2">
                        {{ getForApprovalCount(item) }} For Approval
                      </div>
                    </div>
                  </template>

                  <template v-slot:[`item.actions`]="{ item }">
                    <v-btn
                      :color="$vuetify.theme.themes.light.submitBtnsGreen"
                      variant="text"
                      class="text-none"
                      @click="openSubmission(item)"
                      size="x-small"
                    >
                      View Submission
                    </v-btn>
                  </template>

                  <template #no-data> No data found. </template>
                </v-data-table>
              </v-card>
            </v-col>
          </v-row>
        </div>
      </v-col>
    </v-row>

    <!-- Dialogs -->
    <UploadStudentDialog :data="uploadData" :action="action" />
    <ViewStudentDialog :data="itemData" />
    <ViewSubmissionDialog :data="submission_data" v-on:approval="submission" />
    <ClassSetDialog :data="class_set" :action="action" />

    <v-dialog v-model="dialogConfirmDelete" max-width="500">
      <v-card rounded="lg">
        <v-card-title class="text-h6">Confirm Deletion</v-card-title>
        <v-card-text class="text-body-1">
          Are you sure you want to delete this item?
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            variant="text"
            class="text-none"
            @click="dialogConfirmDelete = false"
            >Cancel</v-btn
          >
          <v-btn
            color="error"
            class="white--text text-none"
            rounded="lg"
            @click="confirmDelete"
            >Confirm</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <fade-away-message-component
      displayType="default"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :type="fadeAwayMessage.type"
    />
  </div>
</template>

<script>
import eventBus from "@/eventBus";
import UploadStudentDialog from "../Dialogs/Forms/UploadStudentDialog.vue";
import ViewStudentDialog from "../Dialogs/Views/ViewStudentDialog.vue";
// import ViewClasslistDialog from "../Dialogs/Views/ViewClasslistDialog.vue";
import ViewSubmissionDialog from "../Dialogs/Views/ViewSubmissionDialog.vue";
import ClassSetDialog from "../Dialogs/Forms/ClassSetDialog.vue";
import { Chart } from "chart.js";
export default {
  components: {
    UploadStudentDialog,
    ViewStudentDialog,
    ViewSubmissionDialog,
    ClassSetDialog,
  },

  // props: {
  //   reloadTable: {
  //     type: Boolean,
  //     required: true,
  //   },
  // },
  data: () => ({
    showDataTable: false,
    search: "",
    headers: [],
    data: [],
    inst_headers: [
      {
        title: "Student Name",
        value: "name",
        align: "start",
        width: 250,
      },

      {
        title: "Progress",
        value: "progress",
        width: 400,
        align: "center",
      },
      {
        title: "Pending review",
        value: "review",
        width: 400,
        align: "center",
      },

      {
        title: "Actions",
        value: "actions",
        align: "center",
        sortable: false,
        width: 200,
      },
    ],
    studentSubmissions: [],
    perPageChoices: [
      { text: "5", value: 5 },
      { text: "10", value: 10 },
      { text: "20", value: 20 },
      { text: "50", value: 50 },
      { text: "100", value: 100 },
      { text: "250", value: 250 },
      { text: "500", value: 500 },
    ],
    activeTab: "Sets",
    tab: 1,
    tabList: [
      { id: 1, name: "Sets" },
      { id: 2, name: "Daily/Weekly Submission" },
    ],
    activeSubmissionTab: "OJT Requirement",
    submissionTab: 1,
    submissionTabList: [
      { id: 1, name: "OJT Requirement" },
      { id: 2, name: "Daily/Weekly Submission" },
    ],
    status_list: [
      { id: 1, name: "For Approval" },
      { id: 2, name: "Approved" },
      { id: 3, name: "Pending" },
    ],
    requirements_headers: [
      {
        title: "Requirement Name",
        value: "requirement_name",
        align: "start",
        width: 250,
      },
      { title: "Status", value: "status", align: "center" },
      { title: "Submission Date", value: "submitted_at", align: "center" },
      {
        title: "Action",
        value: "action",
        align: "center",
      },
    ],
    expandTab1_instructor: false,
    expandTab1: false,
    expandTab2: false,
    expandTab3: false,
    studentData: null,
    studentRequirementIndex: null,
    status_selected: 1,
    totalCount: 0,
    deleteData: null,
    itemData: null,
    uploadData: null,
    alerted: false,
    loading: false,
    options: {},
    action: null,
    paginationData: {},
    formdata: [],
    work_dates_menu: false,
    dialogConfirmDelete: false,
    fadeAwayMessage: {
      show: false,
      type: "success",
      header: "Successfully Deleted!",
      message: "",
      top: 10,
    },
    class_data: null,
    class_data_list: [],
    submission_data: null,
    batch_selected: null,
    batchList: [],
    class_set: null,
    all_student_cnt: 0,
    profileData: [
      { label: "Completed Profile", value: 0, color: "#3BBFA0" },
      { label: "Incomplete Profile", value: 0, color: "#F5A623" },
    ],
    deployData: [
      { label: "Completed", value: 0, color: "#3BBFA0" },
      { label: "Ongoing", value: 0, color: "#F5A623" },
      { label: "Not Started", value: 0, color: "#4E7FE0" },
    ],
    programLabels: [],
    programCompleted: [],
    programIncomplete: [],
    isDataLoaded: false,
    initId: 0,
  }),
  computed: {
    role() {
      const userType = this.$store.state.user?.user?.usertypeID;
      if (userType == 4) return 2; // Pure Instructor always gets instructor role
      return this.$store.getters.getActiveRole;
    },
    getStudentData() {
      let data;
      if (this.studentData) {
        for (let i = 0; i < this.data.length; i++) {
          if (this.studentData.id == this.data[i].id) {
            data = this.data[i];
          }
        }
      }
      return data;
    },

    getStudentRequirement() {
      let arr = [];
      if (this.studentData) {
        arr = this.studentData.requirements;
      }
      return arr;
    },

    getMissingRequirementCount() {
      let count = 0;
      if (this.studentData) {
        let arr = this.studentData.requirements;
        for (let i = 0; i < arr.length; i++) {
          if (arr[i].status == null) {
            count++;
          }
        }
      }

      return count;
    },
    getApprovedRequirementCount() {
      let count = 0;
      if (this.studentData) {
        let arr = this.studentData.requirements;
        for (let i = 0; i < arr.length; i++) {
          if (arr[i].status == 2) {
            count++;
          }
        }
      }

      return count;
    },
    getPendingRequirementCount() {
      let count = 0;
      if (this.studentData) {
        let arr = this.studentData.requirements;
        for (let i = 0; i < arr.length; i++) {
          if (arr[i].status == 3) {
            count++;
          }
        }
      }

      return count;
    },

    completionPct() {
      const total = this.profileData[0].value + this.profileData[1].value;
      return Math.round((this.profileData[0].value / total) * 100);
    },
  },
  watch: {
    role: {
      handler(newV, oldV) {
        if (newV === oldV) return;
        if (newV == 1) {
          this.tabList = [
            { id: 1, name: "Student/OJT Requirement" },
            { id: 2, name: "Daily/Weekly Submission" },
          ];
          this.initialize();
        } else {
          this.status_selected = 1;
          this.tabList = [
            { id: 1, name: "Sets" },
            { id: 2, name: "Daily/Weekly Submission" },
          ];
          this.initialize();
        }
      },
      immediate: true,
    },
  },

  created() {
    this._profileChartInstance = null;
    this._programChartInstance = null;
    this._deployChartInstance = null;
  },
  mounted() {
    this.getBatchList();

    eventBus.on("closeUploadStudentDialog", () => {
      this.initialize();
    });
    eventBus.on("closeViewStudentDialog", () => {
      this.initialize();
    });
    eventBus.on("closeViewClasslistDialog", () => {
      this.initialize();
    });
    eventBus.on("closeViewSubmissionDialog", () => {
      this.initialize();
      // this.loadStudentDataUpdate();
    });
    eventBus.on("closeClassSetDialog", () => {
      this.initialize();
    });
  },

  beforeUnmount() {
    eventBus.off("closeUploadStudentDialog");
    eventBus.off("closeViewStudentDialog");
    eventBus.off("closeViewClasslistDialog");
    eventBus.off("closeViewSubmissionDialog");
    eventBus.off("closeClassSetDialog");

    if (this._profileChartInstance) this._profileChartInstance.destroy();
    if (this._programChartInstance) this._programChartInstance.destroy();
    if (this._deployChartInstance) this._deployChartInstance.destroy();
  },

  methods: {
    pagination(data) {
      this.paginationData = data;
    },
    initialize() {
      this.loading = true;
      this.isDataLoaded = false;
      if (this._profileChartInstance) {
        this._profileChartInstance.destroy();
        this._profileChartInstance = null;
      }
      if (this._programChartInstance) {
        this._programChartInstance.destroy();
        this._programChartInstance = null;
      }
      if (this._deployChartInstance) {
        this._deployChartInstance.destroy();
        this._deployChartInstance = null;
      }

      this.resetArr();

      const callId = ++this.initId;
      setTimeout(async () => {
        if (callId !== this.initId) return;

        if (this.tab == 1) {
          let activeRole = this.role;
          let url = "";
          if (activeRole == 1) {
            url =
              "/student/getAllStudentsByOjtCoordinator?batch=" +
              this.batch_selected;
          } else {
            url = "/student/getMySets";
          }
          try {
            const studentDataPromise = this.axiosCall(url, "GET");
            const studentAnalyticsPromise = this.axiosCall(
              "/student/getCoordinatorAnalytics/" + this.batch_selected,
              "GET",
            );

            if (activeRole == 1) {
              const [studentDataResponse, studentAnalyticsResponse] =
                await Promise.all([
                  studentDataPromise,
                  studentAnalyticsPromise,
                ]);

              this.data = studentDataResponse.data;
              if (!this.showDataTable) {
                const analytics = studentAnalyticsResponse?.data ?? {};
                this.all_student_cnt = analytics.all_student ?? 0;
                this.profileData[0].value = analytics.profile_completed ?? 0;
                this.profileData[1].value = analytics.profile_incomplete ?? 0;
                this.deployData[0].value = analytics.sa_completed_count ?? 0;
                this.deployData[1].value = analytics.sa_no_action_count ?? 0;
                this.deployData[2].value = analytics.sa_ongoing_count ?? 0;

                const distribution = analytics.profile_distribution ?? [];
                for (let i = 0; i < distribution.length; i++) {
                  this.programLabels.push(distribution[i].program);
                  this.programCompleted.push(distribution[i].complete_cnt);
                  this.programIncomplete.push(distribution[i].incomplete_cnt);
                }

                this.isDataLoaded = true;
                await this.$nextTick();

                if (callId !== this.initId) return;

                this.initProfileChart();
                this.initProgramChart();
                this.initDeployChart();
              }
            } else {
              const [studentDataResponse] = await Promise.all([
                studentDataPromise,
              ]);
              if (callId !== this.initId) return;
              this.data = studentDataResponse.data;
            }

            this.headers =
              activeRole == 1
                ? [
                    {
                      title: "Student Name",
                      value: "name",
                      align: "start",
                      width: 250,
                    },
                    { title: "Program", value: "pg_abbr", align: "start" },

                    {
                      title: "Progress",
                      value: "progress",
                      width: 400,
                      align: "center",
                    },
                    {
                      title: "Pending review",
                      value: "review",
                      width: 400,
                      align: "center",
                    },

                    {
                      title: "Actions",
                      value: "actions",
                      align: "center",
                      sortable: false,
                      width: 200,
                    },
                  ]
                : [
                    { title: "Set", value: "name", align: "start" },
                    { title: "Program", value: "abbr", align: "start" },
                    {
                      title: "Actions",
                      value: "actions",
                      align: "center",
                      sortable: false,
                      width: 200,
                    },
                  ];
          } catch (err) {
            console.error(err);
          } finally {
            if (callId === this.initId) {
              this.loading = false;
            }
          }
        } else {
          this.axiosCall(
            "/student-requirement-submission/submissions/getMyStudentOJTSubmissions?status=" +
              this.status_selected,
            "GET",
          ).then((res) => {
            if (res) {
              this.data = res.data;
              this.loading = false;
              this.headers = [
                { title: "Name", value: "name", align: "start" },

                {
                  title: "Set",
                  value: "set_grouping",
                  width: 300,
                  align: "center",
                },
                {
                  title: "Program",
                  value: "program_name",
                  width: 300,
                  align: "center",
                },
                {
                  title: "Submitted File",
                  value: "student_requirement",
                  width: 300,
                  align: "center",
                },

                {
                  title: "Actions",
                  value: "actions",
                  align: "center",
                  sortable: false,
                  width: 200,
                },
              ];
            }
          });
        }
      }, 1000);
    },

    getProgress(item) {
      let submitted = 0;
      for (let index = 0; index < item.requirements.length; index++) {
        if (item.requirements[index].status == 2) {
          submitted++;
        }
      }
      return {
        submitted,
        toSubmit: item.requirements.length,
      };
    },

    getForApprovalCount(item) {
      let submitcount = 0;

      for (let index = 0; index < item.requirements.length; index++) {
        if (item.requirements[index].status == 1) {
          submitcount++;
        }
      }
      return submitcount;
    },

    getStudentSubmissions() {
      this.axiosCall(
        "/student-requirement-submission/submissions/getMyStudentOJTSubmissions?student_id=" +
          this.studentData.id,
        "GET",
      ).then((res) => {
        if (res) {
          this.studentSubmissions = res.data;
        }
      });
    },

    addClassSet() {
      this.action = "Add";
      this.class_set = { id: null };
    },

    updateClassSet(item) {
      this.action = "Update";
      this.class_set = item;
    },

    openGroup1(item) {
      this.studentData = item;
      this.expandTab1 = true;
    },

    openSetGroup(item) {
      this.class_data = item;
      this.expandTab1 = true;
      this.loadClasslist();
      // this.expandTab1_instructor = true;
    },

    openSubGroup(item) {
      this.studentData = item;
      this.expandTab1 = true;
      this.expandTab1_instructor = true;
    },

    openSubmission(item) {
      console.log(item);
      this.submission_data = item;
      this.action = "View";
    },

    loadClasslist() {
      this.axiosCall(
        "/student/getMyStudentBySet/" + this.class_data.id,
        "GET",
      ).then((res) => {
        if (res) {
          // console.log("classDATA", res.data);
          this.class_data_list = res.data;
        }
      });
    },

    loadStudentDailySubmission() {
      this.axiosCall(
        "/student-requirement-submission/submissions/getMyStudentOJTSubmissions?status=1",
        "GET",
      ).then((res) => {
        if (res) {
          this.data = res.data;
        }
      });
    },

    loadStudentDataUpdate() {
      this.studentData = this.getStudentData;
    },

    getStudentSubmissionTableData() {
      this.initialize();
    },

    goBack() {
      if (!this.expandTab1_instructor) {
        this.expandTab1 = !this.expandTab1;
        this.search = null;
        this.loadClasslist();
      } else {
        this.expandTab1_instructor = !this.expandTab1_instructor;
      }
    },

    changeTab(tab) {
      this.expandTab1 = false;
      this.expandTab1_instructor = false;
      this.activeTab = tab.name;
      this.tab = tab.id;
      this.initialize();
    },

    changeSubmissionTab(tab) {
      this.activeSubmissionTab = tab.name;
      this.submissionTab = tab.id;
      if (tab.id == 2) {
        this.requirements_headers = this.headers = [
          {
            title: "Submitted File",
            value: "student_requirement",
            align: "start",
          },

          {
            title: "Status",
            value: "submitted_status",
            width: 300,
            align: "center",
          },

          {
            title: "Submission Date",
            value: "submitted_at",
            width: 300,
            align: "center",
          },

          {
            title: "Actions",
            value: "actions",
            align: "center",
            sortable: false,
            width: 200,
          },
        ];
        this.getStudentSubmissions();
      } else {
        this.requirements_headers = [
          {
            title: "Requirement Name",
            value: "requirement_name",
            align: "start",
            width: 250,
          },
          { title: "Status", value: "status", align: "center" },
          {
            title: "Submission Date",
            value: "submitted_at",
            align: "center",
          },
          {
            title: "Action",
            value: "action",
            align: "center",
          },
        ];
      }
    },
    addnew() {
      this.itemData = [{ id: null }];
      this.action = "Add";
    },
    upload() {
      this.uploadData = { id: null };
      this.action = "Add";
    },
    deleteItem(item) {
      console.log(item);
      this.alerted = true;
      // this.dialogConfirmDelete = true;
      // this.deleteData = item;
    },
    viewItem(item) {
      let activeRole = this.role;
      if (activeRole == 1) {
        if (this.tab == 1) {
          this.itemData = item;
        } else {
          this.submission_data = item;
        }
      } else {
        if (this.tab == 1) {
          this.class_data = item;
        } else {
          this.submission_data = item;
        }
      }
      this.action = "View";
    },

    submission(approval) {
      if (this.studentRequirementIndex) {
        this.studentData.requirements[this.studentRequirementIndex].status =
          approval;
        setTimeout(() => {
          this.studentData.requirements[this.studentRequirementIndex].status =
            approval;
        }, 500);
      } else {
        this.loadStudentDailySubmission();
      }
    },

    getBatchList() {
      this.axiosCall("/student/get-batch-list", "GET").then((res) => {
        this.batchList = res.data;
        this.batch_selected = this.batchList[0].id;
      });
    },

    viewSubmission(item, index) {
      console.log("ASDA", item, index);
      let data = item.submission;
      Object.assign(data, {
        name: this.studentData.name,
        student_requirement: item.requirement_name,
      });
      this.studentRequirementIndex = index;
      this.submission_data = data;
      this.action = "View";
    },
    confirmDelete() {
      this.axiosCall("/request-type/" + this.deleteData.id, "DELETE").then(
        () => {
          this.fadeAwayMessage.show = true;
          this.itemData = null;
          this.initialize();
        },
      );
    },

    resetArr() {
      // this.showDataTable = false;
      this.programLabels = [];
      this.programCompleted = [];
      this.programIncomplete = [];
    },

    // graphs method
    chartDefaults() {
      Chart.defaults.font.family = "'DM Sans', sans-serif";
    },

    initProfileChart() {
      if (this._profileChartInstance) {
        this._profileChartInstance.destroy();
        this._profileChartInstance = null;
      }
      this.chartDefaults();
      this._profileChartInstance = new Chart(this.$refs.profileChart, {
        type: "doughnut",
        data: {
          labels: [...this.profileData.map((d) => d.label)],
          // labels: this.profileData.map((d) => d.label),
          datasets: [
            {
              // data: this.profileData.map((d) => d.value),
              data: [...this.profileData.map((d) => d.value)],
              // backgroundColor: this.profileData.map((d) => d.color),
              backgroundColor: [...this.profileData.map((d) => d.color)],
              borderWidth: 3,
              borderColor: "#fff",
              hoverOffset: 6,
            },
          ],
        },
        options: {
          cutout: "68%",
          plugins: {
            legend: { display: false },
            tooltip: {
              callbacks: {
                label: (ctx) => ` ${ctx.label}: ${ctx.parsed}`,
              },
            },
          },
          animation: { animateRotate: true, duration: 900 },
        },
      });
    },

    initProgramChart() {
      if (this._programChartInstance) {
        this._programChartInstance.destroy();
        this._programChartInstance = null;
      }
      this._programChartInstance = new Chart(this.$refs.programChart, {
        type: "bar",
        data: {
          // labels: this.programLabels,
          labels: [...this.programLabels],
          datasets: [
            {
              label: "Completed",
              // data: this.programCompleted,
              data: [...this.programCompleted],
              backgroundColor: "#3BBFA0",
              borderRadius: 6,
              barPercentage: 0.45,
            },
            {
              label: "Incomplete",
              // data: this.programIncomplete,
              data: [...this.programIncomplete],
              backgroundColor: "#F5A623",
              borderRadius: 6,
              barPercentage: 0.45,
            },
          ],
        },
        options: {
          responsive: true,
          plugins: {
            legend: {
              position: "bottom",
              labels: {
                usePointStyle: true,
                pointStyle: "circle",
                padding: 16,
                font: { size: 11 },
                color: "#8B93A7",
              },
            },
            tooltip: { mode: "index", intersect: false },
          },
          scales: {
            x: {
              grid: { display: false },
              ticks: { color: "#8B93A7", font: { size: 11 } },
              border: { display: false },
            },
            y: {
              beginAtZero: true,
              grid: { color: "#E4E8F0", drawTicks: false },
              ticks: {
                color: "#8B93A7",
                font: { size: 11 },
                stepSize: 20,
                padding: 8,
              },
              border: { display: false, dash: [4, 4] },
            },
          },
          animation: { duration: 900 },
        },
      });
    },

    initDeployChart() {
      if (this._deployChartInstance) {
        this._deployChartInstance.destroy();
        this._deployChartInstance = null;
      }
      this._deployChartInstance = new Chart(this.$refs.deployChart, {
        type: "doughnut",
        data: {
          // labels: this.deployData.map((d) => d.label),
          labels: [...this.deployData.map((d) => d.label)],
          datasets: [
            {
              // data: this.deployData.map((d) => d.value),
              // backgroundColor: this.deployData.map((d) => d.color),
              data: [...this.deployData.map((d) => d.value)],
              backgroundColor: [...this.deployData.map((d) => d.color)],
              borderWidth: 3,
              borderColor: "#fff",
              hoverOffset: 6,
            },
          ],
        },
        options: {
          cutout: "62%",
          plugins: {
            legend: { display: false },
            tooltip: {
              callbacks: {
                label: (ctx) => ` ${ctx.label}: ${ctx.parsed}`,
              },
            },
          },
          animation: { animateRotate: true, duration: 900 },
        },
      });
    },
  },
};
</script>

<style scoped>
.page-title {
  font-size: 30px;
  font-weight: 800;
  color: #1a1a1a;
}

.section-tabs {
  border-bottom: 1px solid #e5e7eb;
}

.back-link {
  color: #519043;
  font-weight: 600;
  width: fit-content;
  transition: opacity 0.15s;
}
.back-link:hover {
  opacity: 0.75;
}

.stat-box {
  height: 100%;
  min-height: 88px;
  transition: opacity 0.15s, transform 0.15s;
}
.stat-box:hover {
  opacity: 0.92;
  transform: translateY(-1px);
}
.card {
  background: #ffffff;
  border-radius: 16px;
  padding: 1.5rem;
  border: 1px solid #d1d5db;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.06);
  transition: box-shadow 0.2s;
}
.card:hover {
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.09);
}

.card-title {
  font-family: "Syne", sans-serif;
  font-size: 0.95rem;
  font-weight: 700;
  letter-spacing: 0.2px;
  margin-bottom: 1.25rem;
  color: #111827;
}

.chart-wrap {
  position: relative;
  width: 100%;
}

/* Donut legend */
.legend {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-top: 1rem;
}
.legend-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.82rem;
  color: #6b7280;
}
.legend-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  flex-shrink: 0;
}
.legend-label {
  flex: 1;
}
.legend-val {
  font-weight: 600;
  color: #111827;
  font-size: 0.85rem;
}

/* Profile card layout */
.profile-inner {
  display: flex;
  gap: 1.25rem;
  align-items: center;
}
.profile-inner .chart-wrap {
  width: 140px;
  flex-shrink: 0;
}
.profile-inner .legend {
  margin-top: 0;
  flex: 1;
}

/* Progress bar */
.progress-bar-wrap {
  margin-top: 0.75rem;
}
.progress-track {
  height: 6px;
  background: #e5e7eb;
  border-radius: 99px;
  overflow: hidden;
}
.progress-fill {
  height: 100%;
  border-radius: 99px;
  background: linear-gradient(90deg, #10b981, #7dd9c2);
  transition: width 1s ease;
}
.progress-labels {
  display: flex;
  justify-content: space-between;
  font-size: 0.75rem;
  color: #6b7280;
  margin-top: 0.4rem;
}
.progress-labels span:first-child {
  color: #10b981;
  font-weight: 600;
}

/* Table cards */
.table-card {
  border-color: #e5e7eb !important;
  overflow: hidden;
}
.styled-table :deep(thead) {
  background-color: #fafafa;
}
.styled-table :deep(th) {
  font-weight: 700 !important;
  color: #4b5563 !important;
  font-size: 0.75rem !important;
  text-transform: uppercase;
  letter-spacing: 0.02em;
}

.program-chip {
  background-color: #eef2ff;
  color: #4338ca;
  font-weight: 600;
  border-radius: 6px;
}

/* Status chips */
.status-chip {
  border-radius: 6px;
  font-weight: 600;
}
.status-review {
  background-color: #e0f2fe;
  color: #0369a1;
}
.status-approved {
  background-color: #dcfce7;
  color: #15803d;
}
.status-pending {
  background-color: #fee2e2;
  color: #b91c1c;
}
.status-none {
  background-color: #f3f4f6;
  color: #6b7280;
}

/* Student summary bar */
.student-summary-bar {
  background-color: #10b9810d;
  border: 1px solid #10b98126;
  border-radius: 12px;
}
.summary-stat-group {
  border: 1px solid #e5e7eb;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.05);
}
</style>
